import React from "react";
import { Loader2 } from "lucide-react";

/**
 * A button that communicates an in-flight action and prevents duplicate submits.
 * Keep the final success or error message in the calling feature's toast/status UI.
 */
export default function AsyncButton({ pending = false, pendingLabel = "Working…", disabled = false, children, ...props }) {
  return (
    <button {...props} disabled={disabled || pending} aria-busy={pending}>
      {pending ? <><Loader2 className="mr-2 inline h-4 w-4 animate-spin" aria-hidden="true" />{pendingLabel}</> : children}
    </button>
  );
}
